<script setup>
import { storeToRefs } from 'pinia';
import { usePageBrandStore } from '@stores/usePageBrandStore';
import { refreshFlickitys } from '@molecules/carousel';
import ShortPagination from './components/ShortPagination.vue';

const store = usePageBrandStore();

const { pagination } = storeToRefs(store);

const goPage = (page) => {
  document.querySelector('.current-page')?.classList.remove('current-page');

  const newCurrentPageElement = document.querySelector(`.page-${page}`);
  newCurrentPageElement.classList.add('current-page');

  document.documentElement.scrollTop = 0;

  const flickityGUIDS = Array.from(newCurrentPageElement.querySelectorAll('.carousel--inner'))
    .map((carousel) => carousel.flickityGUID);

  refreshFlickitys(flickityGUIDS);
  store.setNewPage(page);
};
</script>

<template>
  <ShortPagination
    :offset="pagination.offset"
    :nb-items="pagination.nb_items"
    :page="pagination.page"
    :nb-pages="pagination.nb_pages"
    @go-page="goPage"
  />
</template>
